import * as React from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';

import { WebsiteBuilderPageFormValues } from '@/modules/website-builder/types';

import { ImageAlternativeText } from './ImageAlternativeText';

export const ImageAltTextFields: React.FC<{
  methods: UseFormReturn<WebsiteBuilderPageFormValues, any>;
  alternativeTextName: string;
  isDecorativeName: string;
  imageProxy?: string | null;
}> = ({ methods, alternativeTextName, isDecorativeName, imageProxy }) => {
  return (
    <Controller
      control={methods.control}
      name={isDecorativeName as never}
      defaultValue={true as never}
      render={({ field: decorativeField }) => (
        <Controller
          control={methods.control}
          name={alternativeTextName as never}
          defaultValue={null as never}
          render={({ field: alternativeTextField }) => (
            <ImageAlternativeText
              alternativeText={alternativeTextField.value ?? ''}
              onAlternativeTextChange={(value) =>
                alternativeTextField.onChange(value || null)
              }
              isDecorative={decorativeField.value ?? true}
              onIsDecorativeChange={decorativeField.onChange}
              imageProxy={imageProxy}
            />
          )}
        />
      )}
    />
  );
};
